<!-- @migration-task Error while migrating Svelte code: $$props is used together with named props in a way that cannot be automatically migrated. -->
<script lang="ts">
    import { type ImageEntity } from "../../model/ImageEntity";
    import jQuery from "jquery";
    import { fade } from "svelte/transition";

    export let screenshots: ImageEntity[] = [];
    export let title: string = undefined;

    export let fallbackGraphic: boolean = true;
    let currentIndex = 0;

    let timerHandle;
    const rotationSpeed = 4000;

    let randId = Math.floor(Math.random() * 1000000);

    function rotate() {
        let img = jQuery("#img_" + randId);
        img.fadeOut(200, () => {
            currentIndex = (currentIndex + 1) % screenshots.length;
            img.fadeIn(200);
        });

        if (screenshots.length > 1) {
            timerHandle = setTimeout(rotate, rotationSpeed);
        }
    }

    function changeIndex() {
        let targetIndex = jQuery(this).attr("data-screenshotId");
        currentIndex = parseInt(targetIndex);
        clearTimeout(timerHandle);

        if (screenshots.length > 1) {
            timerHandle = setTimeout(rotate, rotationSpeed);
        }
    }

    if (screenshots.length > 1) {
        timerHandle = setTimeout(rotate, rotationSpeed);
    } else if(!screenshots || screenshots.length == 0) {
        screenshots = [
            {
                url: "assets/demo/slot_generic.png",
                description: "A default placeholder for screenshots of a slot"
            }
        ];
    }
</script>

<div class="{$$props.class}" style="{$$props.style || ""}">
    {#if screenshots && screenshots.length > 0}
        <img
            id="img_{randId}"
            class="w-100 {$$props.class}" style={$$props.style || ""}
            src={screenshots[currentIndex].url}
            alt={screenshots[currentIndex].description}
        />
    {/if}
    <hr class="hr my-2" />
    <nav aria-label="...">
        <ul class="pagination  justify-content-center">
            {#each screenshots as screenshot, i}
                <li
                    class="page-item {currentIndex == i ? 'active' : ''}"
                    aria-current="page"
                >
                    <a
                        data-screenshotId={i}
                        on:click={changeIndex}
                        href="javascript:void(0);"
                        class="page-link">{i + 1}</a
                    >
                </li>
            {/each}
        </ul>
    </nav>
</div>
